import CloudEvent from '../../services/api/CloudEvents/CloudEvent';
import { getPositionObject, getSubject } from '../../services/api/CloudEvents/CloudEventsApi';
import { DATA_OBJ_EVENT_TYPES, EVENT_SOURCE } from '../../services/api/CloudEvents/constants';
import { CONTROLS, PAGES, PLACEMENTS, SLOTS, TYPES } from './constants';

export default class ClickApplyCouponButtonEvent extends CloudEvent {
  constructor({
    userId,
    orderId,
    merchantId,
    idSeam,
    sessionId,
    clientX,
    clientY,
    couponCode,
  }) {
    const subjectParams = {
      userId, orderId, merchantId,
    };
    super(
      EVENT_SOURCE,
      TYPES.CLICK_APPLY_COUPON_BUTTON,
      getSubject(subjectParams),
      idSeam,
    );
    const data = {
      sessionID: sessionId,
      uxContext: {
        page: PAGES.CHECKOUT_DRAWER,
        slot: SLOTS.L5,
        placement: PLACEMENTS.USE_COUPON_CODE_PLACEMENT,
        control: CONTROLS.APPLY_COUPON_BUTTON,
      },
      position: getPositionObject({ clientX, clientY }),
      eventType: DATA_OBJ_EVENT_TYPES.CLICK,
      couponCode,
    };
    this.setData(data);
  }
}
